import type { SimKind } from "./docKinds"

/** One stage of the run, as the ladder shows it (handoff 4, Sim-Start and Sim-Working). */
export interface Rung { stage: string; name: string; seconds: number; does: string }

export const RUNGS: Record<SimKind, Rung[]> = {
  oio: [
    { stage: "intake", name: "Facts", seconds: 30, does: "noticee, SCN, period, heads" },
    { stage: "alignment", name: "Allegations", seconds: 12, does: "each allegation · reply mapped" },
    { stage: "threshold", name: "Threshold", seconds: 18, does: "limitation and section per year" },
    { stage: "findings", name: "Findings", seconds: 47, does: "confirm, reduce or drop each" },
    { stage: "quantum", name: "Quantum", seconds: 30, does: "tax, penalty, interest by code" },
    { stage: "drafting", name: "Draft and check", seconds: 90, does: "the sections, then the self-check" },
  ],
  oia: [
    { stage: "intake", name: "Intake", seconds: 30, does: "the order, the appeal, the record" },
    { stage: "grounds", name: "Grounds", seconds: 20, does: "each ground of appeal" },
    { stage: "preliminary", name: "Preliminary", seconds: 18, does: "time limit, pre-deposit, maintainability" },
    { stage: "findings", name: "Findings", seconds: 50, does: "accept or reject each ground" },
    { stage: "relief", name: "Relief", seconds: 20, does: "what is set aside, by code" },
    { stage: "drafting", name: "Draft and check", seconds: 90, does: "the sections, then the self-check" },
  ],
}

export const totalMinutes = (kind: SimKind) => Math.round(RUNGS[kind].reduce((n, r) => n + r.seconds, 0) / 60)

export type RungState = "done" | "now" | "wait"

/** The stages in order, each with its rough time; while a run goes, done, now and waiting. */
export function Ladder({ kind, state, sub }: {
  kind: SimKind
  state?: (stage: string) => RungState
  /** What a stage says under its name (landed, working, waiting for Continue). */
  sub?: (stage: string) => string | undefined
}) {
  return (
    <ol className="nsl-ladder">
      {RUNGS[kind].map((r) => {
        const st = state?.(r.stage) ?? "wait"
        return (
          <li key={r.stage} className={`nsl-r ${st}`} aria-current={st === "now" ? "step" : undefined}>
            <span className="nsl-dot" aria-hidden="true" />
            <span className="nsl-t"><b>{r.name}</b><span>{sub?.(r.stage) ?? r.does}</span></span>
            <span className="nsl-k mono">{r.seconds} s</span>
          </li>
        )
      })}
    </ol>
  )
}
